var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessConfirmSignupEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.925 27L14.55 20.625L16.65 18.525L20.925 22.8L29.4 14.325L31.5 16.425L20.925 27ZM15 10.5L27 3H3L15 10.5ZM15 13.5L3 6V21H10.725L13.725 24H3C2.175 24 1.46875 23.7063 0.88125 23.1188C0.29375 22.5312 0 21.825 0 21V3C0 2.175 0.29375 1.46875 0.88125 0.88125C1.46875 0.29375 2.175 0 3 0H27C27.825 0 28.5312 0.29375 29.1188 0.88125C29.7063 1.46875 30 2.175 30 3V9.525L27 12.525V6L15 13.5Z",
    fill: "#9D1C49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessConfirmSignupEmail);
export default __webpack_public_path__ + "static/media/success-confirm-signup-email.2ef94eef513a052c3a168ba53284501f.svg";
export { ForwardRef as ReactComponent };